export default "__VITE_ASSET__D0EAjHz5__"